import {toast} from "react-toastify";
import Auth from "../../http_request/Model/auth/Auth";

const GetRoleList = (setRoleList, setLoading) => {


    Auth.request({
        beforeSend: () => {
            setLoading(true)
        },
        success: (result) => {
            setRoleList(result)
        },
        error: ({error}) => {
            toast.error(error.data.message);
        },
        final: () => {
            setLoading(false)
        },
    }).addParams({page: 1, page_size: 100000}).roles()

}
export default GetRoleList